import { useQuery } from "@apollo/client";
import { LocationGenerics } from "router/location";
import { ServiceFeedbackView } from "components/cards";
import { Modal } from "components/layouts";
import { useSearch } from "react-location";
import { GET_SERVICE_FEEDBACK} from "./apollo";


export default function ViewServiceFeedbackContainer({
  open,
  setOpen,
  id,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  id?: string;
}) {
  const searchParams = useSearch<LocationGenerics>();
  const { data, loading } = useQuery(GET_SERVICE_FEEDBACK, {
    variables: {
      id: id || searchParams.id,
    },
    notifyOnNetworkStatusChange: false,
    skip: !id && !searchParams.id
  });

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={loading}
      title="Feedback Information"
      description="Details of service feedback are shown below"
    >
      {data?.feedback?._id && <ServiceFeedbackView feedback={data?.feedback} />}
    </Modal>
  );
}
